<template>
<el-dialog :visible.sync="openDialog" width="1000px" :title="title" :close-on-click-modal="false">
    <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
        <el-row>
            <!-- <el-col :span="12">
                <el-form-item label="报价截止时间" prop="bjJzTime">
                    <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"
                        v-model="form.bjJzTime"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="询价单号" prop="xjOrder">
                    <el-input v-model="form.xjOrder" placeholder="请输入询价单号" />
                </el-form-item>
            </el-col> -->
            <el-col :span="12">
                <el-form-item label="采购标题" prop="title">
                    <el-input v-model="form.title" placeholder="请输入采购单标题" />
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="采购方式" prop="xjFs">
                    <el-select v-model="form.xjFs" style="width: 100%" placeholder="请选择采购方式">
                        <el-option v-for="item in xjtypesDict" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="采购部门" prop="unitId">
                    <!-- <el-input v-model="form.buyerUnitId" placeholder="请输入发起单位" /> -->
                    <el-select v-model="form.unitId" style="width: 100%" placeholder="请选择采购部门">
                        <el-option :label="org.deptName" :value="org.id" v-for="org in purchaseDeptArr" :key="org.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="采购组织" prop="buyerUnitId">
                    <el-select v-model="form.buyerUnitId" style="width: 100%" placeholder="请选择采购组织">
                        <el-option :label="org.deptName" :value="org.id+''" v-for="org in stockOrgArr" :key="org.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="币种" prop="currency">
                    <el-select v-model="form.currency" filterable style="width: 100%" placeholder="请选择币种">
                        <el-option v-for="item in currencyData" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="项目类型" prop="projectType">
                    <el-select v-model="form.projectType" filterable style="width: 100%" placeholder="请选择项目类型">
                        <el-option v-for="item in projectTypeOption" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
                <el-form-item label="业务实体" prop="ywSt">
                    <el-input v-model="form.ywSt" placeholder="请输入业务实体" />
                </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
                <el-form-item label="单据类型" prop="djType">
                    <el-input v-model="form.djType" placeholder="请输入单据类型" />
                </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
                <el-form-item label="是否含税" prop="isConcatTax">
                    <el-select v-model="form.isConcatTax" style="width: 100%" placeholder="请选择是否含税">
                        <el-option label="是" value="是"></el-option>
                        <el-option label="否" value="否"></el-option>
                    </el-select>
                </el-form-item>
            </el-col> -->
            <el-col :span="24">
                <el-form-item label="附件" prop="fileSrc">
                    <el-upload class="upload-demo" :action="upload()" :show-file-list="false"
                        accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
                        <el-input style="width:100%" v-model="form.fileSrc" placeholder="点击文本框上传" readonly slot="trigger" />
                    </el-upload>
                </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="招标公告：" prop="remark">
                <WangEditor v-if="openDialog" ref="WangEditorRef" @callback="WangEditorCallback" :content="form.remark" editHeight="500" />
              </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
    </span>
</el-dialog>
</template>
<script>
import {
    srmXjOrderList,
    addSrmXjOrder,
    editSrmXjOrder,
    delSrmXjOrder,
    batchDelSrmXjOrder,
    exportSrmXjOrder,
} from '@/api/srm/srmXjOrder.js';
import { queryAllDeptList } from '@/api/system/dept.js';
import { xjtypes,projectTypeOption } from'@/utils/dict'
import WangEditor from "@/components/WangEditor.vue";
export default {
  components: {WangEditor},
    props:['currencyData'],
    data(){
		return {
			title: "",
            stockOrgArr:[],     // 采购组织
            purchaseDeptArr:[], // 采购部门
			openDialog: false,
			form: {
        remark:'',
      },
            rules: {
                title: [{
                    required: true,
                    message: '请输入询价单标题',
                    trigger: 'blur'
                }],
                buyerUnitId: [{
                    required: true,
                    message: '请选择采购组织',
                    trigger: 'blur'
                }],
                unitId: [{
                    required: true,
                    message: '请选择采购部门',
                    trigger: 'blur'
                }],
                xjFs: [{
                    required: true,
                    message: '请输入询价方式',
                    trigger: 'blur'
                }],

                currency: [{
                    required: true,
                    message: '请输入币种',
                    trigger: 'blur'
                }],
                projectType: [{
                    required: true,
                    message: '请选择项目类型',
                    trigger: 'blur'
                }],
                remark: [{
                  required: true,
                  message: '请输入招标公告',
                  trigger: 'blur'
                }],
            },
            // 询价方式字典
            xjtypesDict:xjtypes,
            projectTypeOption:projectTypeOption,
        }
    },
    mounted(){
        this.queryCGZZDeptList();
        this.queryCGBMDeptList();
    },
    methods:{
        openDialogFun(row,title){
          this.title = title;
          this.reset();
          if(row){
            debugger
            this.form={
              id:row.id,
              title:row.title,
              announcementType:row.announcementType+'',
              remark:row.remark,
              // content:'09090909090',
              announcementFileList:row.announcementFileList,
              publicHomePage:row.publicHomePage
            }
          }
          console.log(this.form.content)
          this.openDialog = true;
          this.$nextTick(()=>{
            this.$refs.WangEditorRef.init(this.form.content)
          })
        },
        // 获取采购组织
        async queryCGZZDeptList() {
            let _this = this;
            const {
                data: res
            } = await queryAllDeptList({purchaseOrg:'是'})
            if (res.code == 0) {
                _this.stockOrgArr = res.data || [];
            }
        },
        // 获取采购部门
        async queryCGBMDeptList() {
            let _this = this;
            const {
                data: res
            } = await queryAllDeptList({purchaseDept:'是'})
            if (res.code == 0) {
                _this.purchaseDeptArr = res.data || [];
            }
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 0) {
                this.$success(res.msg);
                if (this.form.fileSrc != "" && this.form.fileSrc != undefined) {
                    //如果修改附件 则删除原来的附件
                    if (this.form.fileSrc != res.data.url) {
                        this.delFile(this.form.fileSrc);
                    }
                }
                this.form.fileSrc = res.data.url;
            }
        },
        beforeAvatarUpload(file) {
            //      let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$fail('上传附件大小不能超过 2MB!');
            }
            return isLt2M;
        },
        // 表单重置
        reset: function() {
            this.form = {
                id: undefined,
                createUser: this.$store.getters['user/user'].id,
                title: undefined,
                buyerUnitId: undefined,
                xjFs: undefined,

                currency: undefined,
                projectType: undefined,
                // isConcatTax: undefined,
                fileSrc: undefined,
                // fbTime: undefined,
                remark: undefined,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.form.content = _this.$refs.WangEditorRef.editorData;
            console.log( _this.form.content)
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (_this.form.id != undefined) {
                        editSrmXjOrder(_this.form).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:2})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    } else {
                        addSrmXjOrder(_this.form).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:2})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
        WangEditorCallback(obj){
          if(obj.type == 'editorContent'){
            this.form.remark = obj.value;
            this.$refs.form.validateField('remark');
          }
        }
    }
}
</script>
<style scoped="scoped">
</style>
